import {TenantAdminExtensionsTab, TenantAdminTab} from './TenantAdminConstants';

export enum TenantAdminActionType {
  TENANT_ADMIN_CHANGE_ACTIVE_TAB = 'TENANT_ADMIN_CHANGE_ACTIVE_TAB',
  TENANT_ADMIN_CHANGE_ACTIVE_EXTENSIONS_TAB = 'TENANT_ADMIN_CHANGE_ACTIVE_EXTENSIONS_TAB',
}

export interface TenantAdminActiveTabChangeAction {
  type: TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_TAB;
  tab: TenantAdminTab;
}

export interface TenantAdminActiveExtensionsTabChangeAction {
  type: TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_EXTENSIONS_TAB;
  tab: TenantAdminExtensionsTab;
}

export function changeActiveTab(tab: TenantAdminTab): TenantAdminActiveTabChangeAction {
  return {
    type: TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_TAB,
    tab,
  };
}

export function changeActiveExtensionsTab(
  tab: TenantAdminExtensionsTab
): TenantAdminActiveExtensionsTabChangeAction {
  return {
    type: TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_EXTENSIONS_TAB,
    tab,
  };
}

export type TenantAdminAction = TenantAdminActiveTabChangeAction | TenantAdminActiveExtensionsTabChangeAction;
